// extracted by mini-css-extract-plugin
export default {"features":"FeaturesSection_features__ueKTJ","h4":"FeaturesSection_h4__kDpHA"};